import React from 'react';
import createSvgIcon from '@mui/icons-material/utils/createSvgIcon';
import parseColor from '../util/parseColor';
import { styled } from '../styled';

const Icon = createSvgIcon(
  <svg viewBox='0 0 20 12' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M2 12C1.45 12 0.979167 11.8042 0.5875 11.4125C0.195833 11.0208 0 10.55 0 10V2C0 1.45 0.195833 0.979167 0.5875 0.5875C0.979167 0.195833 1.45 0 2 0H18C18.55 0 19.0208 0.195833 19.4125 0.5875C19.8042 0.979167 20 1.45 20 2V10C20 10.55 19.8042 11.0208 19.4125 11.4125C19.0208 11.8042 18.55 12 18 12H2ZM5.25 9H6.75V6.75H9V5.25H6.75V3H5.25V5.25H3V6.75H5.25V9Z'
      fill='currentColor'
    />
  </svg>,
  'ButtonsAlt',
);

const ColoredIcon = styled(Icon)(({ theme, color }) => ({
  color: parseColor(theme, color),
}));

export default ColoredIcon;
